import validateProspect from "./validateProspect";
import validateSas from "./validateSas";

const sasTemplate = {
  blue: validateSas,
  'bmw-gold': validateSas,
  'bmw-premium': validateSas,
  'bmw-silver': validateSas,
  bmw: validateSas,
  'dm-payback': validateSas,
  gold: validateSas,
  green: validateSas,
  mini: validateSas,
  payback: validateSas,
  platinum: validateSas,
  'sixt-gold': validateSas,  
  sixt: validateSas,
  'bmw-blue': validateSas,
  'gold-plastic': validateSas,
};

const prospectTemplate = {
  platinum: validateProspect,
  gold: validateProspect,
  'gold-3gc': validateProspect,
  'gold-3f6': validateProspect,
  blue: validateProspect,
  green: validateProspect,
  'green-6d5': validateProspect,
  payback: validateProspect,
  'dm-payback': validateProspect,
  bmw: validateProspect,
  'bmw-premium': validateProspect,
  'platinum-plus': validateProspect,
  'cobaplatinum-plus': validateProspect,
  'gold-rose': validateProspect,
  'bmw-blue': validateProspect,
};

const template = {
  prospect: prospectTemplate,
  sas: sasTemplate
};

export type Channel = keyof typeof template;
export type Product = keyof typeof prospectTemplate;
export type SasProduct = keyof typeof sasTemplate;

const getTemplateMapper = (channel: Channel, product: Product | SasProduct) => {
  const channelData = template?.[channel];
  return (channelData as typeof sasTemplate & typeof prospectTemplate)?.[product];
};

export default getTemplateMapper;
